var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-advert"},[_c('error',{attrs:{"errors":_vm.navigationError}}),_c('navigation-form',{attrs:{"action":"edit"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }